// extracted by mini-css-extract-plugin
module.exports = {"goalsSummary":"style__goalsSummary__2PUx+"};